import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Radio, TextField, Typography, useMediaQuery } from '@mui/material';
import { fetchLoginUser, fetchReleaseAlbum, fetchSongReleaseList, fetchUserDetail, setLoader, setSnackBar, setSnackBarMessage, setSnackBarVariant } from '../../redux';
import imgPlaceHolder from '../../img/general/PlaceholderImg.webp'
import { formatDateTime, getDateAsPerFormat, getTime } from '../../_helpers/reusablefunctions/dateSetter';
import { getSongStatusBgColor } from '../../_helpers/reusablefunctions/getColor';
import AudioPlayer from '../../components/reusableComponents/customAudioPlayer';
import { useRef } from 'react';
import { getSingleSongDetails } from '../../_services/submitAsong/getSingleSong.service';
import { formSnackbar } from '../../_services/_constants/snackbar.constant';
import { songApproved } from '../../_services/songApprover/postSongApprover';
import { songApproverEdit } from '../../_services/songApprover/putSongApprover';
import { getAprrover } from '../../_services/songApprover/getSongApprover';
import SnackbarContainer from '../Snackbar';
import { submitSong } from '../../_services/submitAsong/submitAsong.service';
import { albumApprover } from '../../_services/songApprover/albumApprover';
import { GetApp } from '@mui/icons-material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Zoom from '@mui/material/Zoom';
import ApiService from '../../_services/ApiService';
import PreviewIcon from '@mui/icons-material/Preview';
import ArtistList from '../../components/reusableComponents/EntityList';


const SongDetails = () => {
  const smScreen = useMediaQuery('(max-width:768px)')
  const lgScreen = useMediaQuery('(max-width:1280px)')
  const history = useHistory();
  const dispatch = useDispatch();
  const { songId, albumId } = useParams();
  const [buttonText, setButtonText] = useState('Lock-in');
  const [songStatus, setSongStatus] = useState('');
  const [boxEnabled, setBoxEnabled] = useState('');
  const [selectedValue, setSelectedValue] = useState('True');
  const [comment, setComment] = useState('');
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const scrollRef = useRef(null);
  const [error, setError] = useState('');
  const userData = useSelector(state => state.userData.userData)
  const [songDetails, setSongDetails] = useState([]);
  const [isApproved, setIsApproved] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [songInfo, setSongInfo] = React.useState()
  const [isRejected, setIsRejected] = useState(true);
  const [isHidden, setIsHidden] = useState(true);
  const [isCommentValid, setIsCommentValid] = useState(false);
  const [isLocked, setIsLocked] = useState('');

  // Convert track property slugs (e.g. "remix_or_derivative") into readable labels (e.g. "Remix Or Derivative")
  const formatTrackProperty = (value) =>
    value
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      maxWidth: '13.9rem',
    },
  }));

  useEffect(() => {
    if (userData.id) {
      dispatch(fetchLoginUser(userData.id));
      // getData(songId);
    }
    if (songId) {
      // dispatch(fetchSongReleaseList());
      getSongDetails(userData.id, songId);
      getData(songId);
    }
  }, [songId]);


  useEffect(() => {

    if (songDetails) {
      const song = songDetails;
      setComment(song?.comment)
      setSongStatus(song.song_status);
      if (song?.song_status === 'Released') {
        setIsSubmitDisabled(true);
      }
      if (song?.song_status === 'Rejected') {
        setSelectedValue('False');
        setIsSubmitDisabled(false);
      }
      if (song?.song_status === 'In Review' && comment == "") {
        setIsSubmitDisabled(true);
      } else {
        setIsSubmitDisabled(false);

      }
    }
  }, [songDetails]);
  function updateSongMeta(postData) {
    submitSong(postData, 'UPDATE')
      .then((response) => {
        //  dispatch(fetchSongReleaseList());
        getSongDetails(userData.id, songId)
        dispatch(setLoader(false));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        dispatch(setSnackBar(true));
        setTimeout(() => dispatch(setSnackBar(false)), 2000);
        dispatch(setSnackBarVariant('error'));
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
      });
  }
  function getSongDetails(userId, song_id) {
    dispatch(setLoader(true))
    getSingleSongDetails({ 'userId': userId, 'song_id': song_id }, 'GET_SPECIFIC_DISPLAY').then(function (response) {
      dispatch(setLoader(false))
      if (response.status === 200) {
        setSongDetails(response.data.data)
        setSongInfo(response.data.data)
        setSongStatus(response.data.data.song_status)
        setComment(response.data.data.comment);
      }
      else {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 3000)
      }
    }).catch(function (error) {
      dispatch(setSnackBar(true));
      dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
      dispatch(setSnackBarVariant('error'));
      setTimeout(() => dispatch(setSnackBar(false)), 3000)
      return error.response;
    })
  }
  function getData(songId) {
    dispatch(setLoader(true));
    // getAprrover('GET')
    ApiService.get("getParticularSongApproval", { 'song_id': songId })
      .then(function (response) {
        dispatch(setLoader(false));
        if (response.status === 200) {
          setIsApproved(response.data.data);
          let result = response.data.data.filter((item) => item.song_id.toString() === songId);
          setFilterData(result);
        } else {
          dispatch(setSnackBar(true));
          dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
          dispatch(setSnackBarVariant('error'));
          setTimeout(() => dispatch(setSnackBar(false)), 3000);
        }
      })
      .catch(function (error) {
        dispatch(setLoader(false));
        dispatch(setSnackBar(true));
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 3000);
        return error.response;
      });
  }


  //to handle the back navigation
  const handleRouteBack = () => {
    history.push('/albumdetail/' + albumId)
  }

  // Update song metadata and perform related actions
  useEffect(() => {
    if (boxEnabled !== '') {
      const postData = new FormData();
      postData.append('song_id', songId);
      postData.append('is_locked', isLocked);
      updateSongMeta(postData);
      if (boxEnabled === 'True') {
        setButtonText('Lock-out');
      } else {
        setButtonText('Lock-in');
      }
    }
  }, [boxEnabled]);

  const handleCommentChange = (event) => {
    const inputValue = event.target.value;
    setComment(inputValue);
    setIsCommentValid(inputValue.length >= 30 && inputValue.length <= 1000);
  };

  const handleRadioButtonChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const [audioUrl, setAudioUrl] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    // Fetch the audio URL
    fetch(songInfo?.song_file)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        setAudioUrl(url);
      })
      .catch(error => console.error('Error fetching audio:', error));

    // Fetch the image and convert it to base64
    const imageUrl = songInfo && songInfo.cover_image ? process.env.REACT_APP_SONGAPIURL_MEDIA + songInfo.cover_image : '';
    let imageHtml = '';
    fetch(songInfo?.cover_image)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          imageHtml = `<img src="${base64data}" alt="Cover Image" style="width: 200px; height: auto;" />`;
          setImageUrl(base64data);
        };
      })
      .catch(error => console.error('Error fetching image:', error));
  }, [songInfo?.song_file, songInfo?.cover_image != undefined]);

  const handleDownload = () => {
    // Create a blob with song metadata
    const blob = new Blob([
      `Song Title: ${songInfo?.song_name}
                           \nExplicit Content:${songInfo?.explicit_content ? 'Yes' : 'No'}
                           \nGenre: ${songInfo?.genre}
                           \nMood:${songInfo?.mood}
                           \nISRC Code:${songInfo?.isrc_code}
                           \nSub Genre:${songInfo?.sub_genre}
                           \nInstrumental:${songInfo?.instrumental ? 'Yes' : 'No'}
                           \nUPC Code:${songInfo.upc_code != null ? songInfo.upc_code : ""}
                           \nPrimary Artist: ${songInfo.primary_artists.length > 0 && songInfo.primary_artists[0].artist_name}
                           \nFeaturing Artist: ${songInfo.featuring_artists.length > 0 && songInfo.featuring_artists[0].artist_name}
                           \nComposer:${songInfo.composers.length > 0 && songInfo.composers[0].artist_name}
                           \nProducer:${songInfo.producers.length > 0 && songInfo.producers[0].artist_name}
                           \nActor:${songInfo.actors.length > 0 && songInfo.actors[0].artist_name}
                           \nLyricist:${songInfo.lyricists.length > 0 && songInfo.lyricists[0].artist_name}
                           \nRealease Date:${songInfo.release_date ? getDateAsPerFormat(songInfo.release_date, "DD Mon, YYYY") : ''}
                           \nRecord Label:${songInfo.record_labels && songInfo.record_labels.join(',')}
                           \nLanguage:${songInfo.language && songInfo.language}
                           \nRelease Time:${songInfo.release_time ? getTime(songInfo.release_time) : ''}
                           \nSong Lyrics:${songInfo.song_lyrics ? songInfo.song_lyrics : ''}
                           \nSong Description:${songInfo.song_description ? songInfo.song_description : ''}
                           \n© Copyright Year": ${songInfo.copyright_c ? songInfo.copyright_c && songInfo.copyright_c.copyright_year.copyright_year : "--"}
                           \n© Copyright : ${songInfo.copyright_c ? songInfo.copyright_c.copyright_name : "--"}
                           \n℗ Publishing Year: ${songInfo.copyright_p ? songInfo.copyright_p && songInfo.copyright_p.copyright_year.copyright_year : "--"}
                           \n℗ Copyright: ${songInfo.copyright_p ? songInfo.copyright_p.copyright_name : "--"}
                           \nHas it been previously released?: ${songInfo.release_history === 'False' || songInfo.release_history === false ? 'No' : 'Yes'}
                           \nPrevious Release Date:${(songInfo.release_history === 'False' || songInfo.release_history === false) ? "--" : songInfo.previous_release_date == null || songInfo.previous_release_date == '' ? '--' : getDateAsPerFormat(songInfo.previous_release_date, "DD Mon, YYYY")}
                         

                           ` ], { type: 'text/plain' });

    const url = URL.createObjectURL(blob);

    // Create a hidden link element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.download = `${songInfo.song_name}.doc`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = async (e, albumId) => {
    e.preventDefault();

    // if (!isCommentValid && selectedValue === "False") {
    //   setError('Comment must be between 30 and 1000 characters');
    //   return;
    // }
    if (selectedValue === "False" && !isCommentValid) {
      setError('Comment must be between 30 and 1000 characters');
      return;
    }
    setError('');

    if (selectedValue === "True") {
      if (!songInfo?.isrc_code || songInfo?.isrc_code.trim() === "") {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarVariant("error"));
        dispatch(setSnackBarMessage("ISRC Code is mandatory to approve the song."));
        setTimeout(() => dispatch(setSnackBar(false)), 3000);
        return;
      }
      if (!songInfo?.upc_code || songInfo?.upc_code.trim() === "") {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarVariant("error"));
        dispatch(setSnackBarMessage("UPC Code is mandatory to approve the song."));
        setTimeout(() => dispatch(setSnackBar(false)), 3000);
        return;
      }
    }
    setError('');
    if (!songId) return;

    console.log("Validation passed ✅");
    console.log("Selected Action:", selectedValue === "True" ? "Approve" : "Reject");
    console.log("Comment:", comment);
    console.log("ISRC:", songInfo?.isrc_code);
    console.log("UPC:", songInfo?.upc_code);

    dispatch(setSnackBar(true));
    dispatch(setSnackBarVariant('info'));
    dispatch(setSnackBarMessage(formSnackbar.songAprrovedStatus.statusUpdating));
    dispatch(setLoader(true));

    const isApproved = selectedValue === 'True';
    const isRedelivery = songStatus === "Redelivery Requested";

    const commonPostData = {
      song_status: isApproved
        ? isRedelivery ? 'Ready for Redelivery' : 'Ready for Release'
        : 'Rejected',
      redelivery_comment: isRedelivery ? (isApproved ? 'Approved' : comment) : '',
      // comment: !isRedelivery ? (isApproved ? 'Approved' : comment) : '',
      comment: !isRedelivery ? (isApproved ? comment : comment) : '',
      approver_user_id: userData.id,
      song_id: songId,
      is_approved: selectedValue,
    };

    setSongStatus(commonPostData.song_status);
    if (!isApproved) setSelectedValue('False');

    const onSuccess = (response, isFromSongApproverEdit) => {
      dispatch(setLoader(false));
      dispatch(setSnackBarVariant('success'));
      dispatch(setSnackBarMessage(formSnackbar.songAprrovedStatus.statusUpdatingSuccess));
      setTimeout(() => dispatch(setSnackBar(false)), 2000);
      dispatch(fetchUserDetail());
      getData(songId);
      getSongDetails(userData.id, songId);

      if (isApproved) {
        submitButtonText = 'Release';
      } else {
        setIsRejected(true);
        setIsHidden(true);
        setIsLocked('False');
        const data = isFromSongApproverEdit ? response.data : response.data.data[0].fields;
        setComment(data.comment);
        setSongStatus(data.song_status);
      }
    };

    const onFailure = () => {
      dispatch(setLoader(false));
      dispatch(setSnackBarVariant('error'));
      dispatch(setSnackBarMessage(formSnackbar.serviceRequest.serviceRequestFailure));
      setTimeout(() => dispatch(setSnackBar(false)), 3000);
    };

    try {
      if (filterData.length > 0) {
        const response = await songApproverEdit(songId, commonPostData);
        response.status === 200 ? onSuccess(response, true) : onFailure();
      } else {
        const response = await songApproved(commonPostData, userData.id);

        if (response.status === 200) {
          if (!isApproved) {
            const albumPostData = {
              song_status: 'Rejected',
              approver_user_id: userData.id,
              album_id: albumId,
            };
            try {
              await ApiService.post("albumpostApproval", albumPostData);
            } catch (e) {
              // silently fail album post approval
            }
          }
          onSuccess(response, false);
        } else {
          onFailure();
        }
      }
    } catch (error) {
      onFailure();
    }
  };


  if (!songInfo) {
    return <h1>Loading...</h1>;
  }

  let submitButtonText = 'Approve';
  if (selectedValue === 'True') {
    submitButtonText = 'Approve';
  } else if (selectedValue === 'False') {
    submitButtonText = 'Reject';
  }


  return (
    <div style={{ padding: '1rem 1rem 3rem' }} >
      <div className="d-flex justify-content-between align-items-center">
        <div className=''>
          <button className="icononly-btn d-flex" onClick={handleRouteBack}>
            <ArrowBackIcon /> <p className='cardheading ms-2'>{songInfo?.album?.[0]?.album_name}</p>
          </button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 4 }} >
          {/* <Tooltip> */}
          {/* {songInfo.song_status == "Redelivery Requested" && <BootstrapTooltip title=' redelivery data' ransitioncomponent={Zoom} >
            <button className="gn-actionbtn fs-08" onClick={() => history.push(`/song-meta/${songId}/${albumId}`, { album_history: 'song_history', albumData: songInfo })}>
              <PreviewIcon sx={{ width: "18px" }} />
            </button>
          </BootstrapTooltip>} */}
          <BootstrapTooltip title='Download Song Meta' ransitioncomponent={Zoom} >
            <button className="gn-actionbtn"
              onClick={handleDownload}>
              <GetApp sx={{ width: "18px" }} />
            </button>
          </BootstrapTooltip>
          {/* </Tooltip> */}
        </div>
      </div>
      <div className="mt-4">
        <div className={`d-flex flex-wrap justify-content-between ${smScreen ? '' : 'px-1'}`}>
          <div className="verifyCol1 p-4 shadow bg-white rounded">
            <div className={`d-flex ${smScreen ? 'flex-wrap' : ''}`}>
              <div className={`flex-grow-1 ${smScreen ? 'w-100' : 'w-50'}`}>
                <div className="d-flex align-items-center">
                  <span className="fs-6 text-secondary">New Release</span>
                  <hr style={{ flexGrow: '1', border: '1px solid rgba(0, 0, 0, 0.12)' }} />
                </div>
                <div>
                  <div>
                    <div className="value-pair">
                      <strong>Song Name: </strong>
                      <span>{songInfo.song_name}</span>
                    </div>
                    <div>
                      <div className="value-pair">
                        <div style={{ backgroundColor: getSongStatusBgColor(songStatus) }} className="status text-light">{songStatus == "Ready for Release" ? 'Approved' : songStatus}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row 2 */}
            <div>
              <div className="my-3">
                <AudioPlayer songTitle={songInfo?.song_name} type='small' audioSrc={process.env.REACT_APP_SONGAPIURL_MEDIA + songInfo.song_file} />
              </div>
            </div>
            {/* row 3 */}
            <div className="d-flex justify-content-between flex-wrap">
              <div className={`${smScreen ? 'w-100' : 'w-50'}`}>
                <div className="value-pair">
                  <strong>Explicit Content: </strong>
                  <span>{songInfo.explicit_content ? 'Yes' : 'No'}</span>
                </div>
                <div className="value-pair">
                  <strong>Genre: </strong>
                  <span>{songInfo.genre}</span>
                </div>
                <div className="value-pair">
                  <strong>Mood: </strong>
                  <span>{songInfo.mood}</span>
                </div>
                <div className="value-pair">
                  <strong>ISRC Code: </strong>
                  <span>{songInfo.isrc_code}</span>
                </div>
                <div className='value-pair'>
                  <strong>What’s the origin of the track? :</strong>
                  <span>{songInfo.copyright_type === 'False' || songInfo.copyright_type === 'false' ? ' Public Domain' : ' Original Song'}</span>
                </div>
                <div className="value-pair">
                  <strong>Ⓟ Publishing Year: </strong>
                  <span> {songInfo.copyright_p && songInfo.copyright_p.copyright_year.copyright_year}</span>
                </div>
                <div className="value-pair">
                  <strong>© Copyright Year:</strong>
                  <span>{songInfo.copyright_c && songInfo.copyright_c.copyright_year.copyright_year}</span>
                </div>
                <div className="value-pair">
                  <strong>Song Lyrics: </strong>
                  <span>{songInfo.song_lyrics || "--"}</span>
                </div>
              </div>
              <div className={`${smScreen ? 'w-100' : 'w-50'}`}>
                <div className="value-pair">
                  <strong>Sub-Genre: </strong>
                  <span>{songInfo.sub_genre}</span>
                </div>
                <div className="value-pair">
                  <strong>Instrumental: </strong>
                  <span>{songInfo.instrumental ? 'Yes' : 'No'}</span>
                </div>
                {/* <div className="value-pair">
                  <strong>UPC Code: </strong>
                  <span>{songInfo.upc_code}</span>
                </div> */}
                <div className="value-pair">
                  <strong>Release History: </strong>
                  <span>{songInfo.release_history ? "Yes" : "No"}</span>
                </div>
                <div className="value-pair">
                  <strong>Ⓟ Copyright:</strong>
                  <span>{songInfo.copyright_p && songInfo.copyright_p.copyright_name}</span>
                </div>
                <div className="value-pair">
                  <strong>© Copyright:</strong>
                  <span>{songInfo.copyright_c && songInfo.copyright_c.copyright_name}</span>
                </div>
                <div className="value-pair">
                  <strong>Language: </strong>
                  <span>{songInfo.language || "--"}</span>
                </div>
                <div className="value-pair">
                  <strong>Song Description: </strong>
                  <span>{songInfo.song_description || "--"}</span>
                </div>
                <div className="value-pair">
                  <strong>Album Name: </strong>
                  <span>{songInfo.album?.length > 0 ? songInfo.album[0].album_name : "--"}</span>
                </div>

                <div className="value-pair">
                  <strong>Title Version: </strong>
                  <span>{songInfo.title_version || "--"}</span>
                </div>
                <div className="value-pair">
                  <strong>Track Properties: </strong>
                  <span>
                    {Array.isArray(songInfo.track_properties)
                      ? (songInfo.track_properties.length > 0
                          ? songInfo.track_properties.map(formatTrackProperty).join(', ')
                          : "--")
                      : (songInfo.track_properties || "--")}
                  </span>
                </div>
                {/* <div className="value-pair">
                  <strong>© Copyright:</strong>
                  <span>{songInfo.copyright_c && songInfo.copyright_c.copyright_name} {songInfo.copyright_c && songInfo.copyright_c.copyright_year.copyright_year}</span>
                </div>
                <div className="value-pair">
                  <strong>© Copyright:</strong>
                  <span>{songInfo.copyright_c && songInfo.copyright_c.copyright_name} {songInfo.copyright_c && songInfo.copyright_c.copyright_year.copyright_year}</span>
                </div> */}
              </div>
            </div>
          </div>
          {/* space */}
          <div style={{ width: '20px', height: '20px' }}></div>
          {/* column2 */}
          <div className="verifyCol2 p-4 shadow bg-white rounded">
            <div className="d-flex align-items-center">
              <span className="fs-6 text-secondary">Song Credit</span>
              <hr className="ms-2" style={{ flexGrow: '1', border: '1px solid rgba(0, 0, 0, 0.12)' }} />
            </div>
            <div className="d-flex justify-content-between flex-wrap">
              <div className={`${smScreen ? "w-100" : "w-50"} pe-2`}>
                {songInfo.primary_artists.length > 0 && <div className="value-pair">
                  <strong>Primary Artist: </strong>
                  <ArtistList artists={songInfo.primary_artists} />
                </div>}
                {songInfo.composers.length > 0 && <div className="value-pair">
                  <strong>Composer: </strong>
                  <ArtistList artists={songInfo.composers} />
                </div>}
                {songInfo.producers.length > 0 && <div className="value-pair">
                  <strong>Producer: </strong>
                  <ArtistList artists={songInfo.producers} />
                </div>}
                {songInfo.actors.length > 0 && <div className="value-pair">
                  <strong>Actor: </strong>
                  <ArtistList artists={songInfo.actors} />
                </div>}
              </div>

              <div className={`${smScreen ? "w-100" : "w-50"} ps-2`}>
                {songInfo.featuring_artists.length > 0 && <div className="value-pair">
                  <strong>Featuring Artist: </strong>
                  <ArtistList artists={songInfo.featuring_artists} />
                </div>}
                {songInfo.lyricists.length > 0 && <div className="value-pair">
                  <strong>Lyricist: </strong>
                  <ArtistList artists={songInfo.lyricists} />
                </div>}
                {songInfo.remixers.length > 0 && <div className="value-pair">
                  <strong>Remixer: </strong>
                  <span>
                    <ArtistList artists={songInfo.remixers} />
                  </span>
                </div>}
              </div>
            </div>

            <div className="d-flex justify-content-between flex-wrap mt-3">
              <div className="w-100">
                {songInfo.singers.length > 0 && <div className="value-pair">
                  <strong>Singer: </strong>
                  <ArtistList artists={songInfo.singers} />
                </div>}

              </div>
            </div>

            {/* <div className="d-flex justify-content-between flex-wrap mt-3">
              <div className="w-100">

                

              </div>
            </div> */}
          </div>
        </div>
        <div ref={scrollRef}>

          <div className={`d-flex flex-wrap justify-content-between ${smScreen ? 'px-0' : 'px-3'} mt-4 mb-4`}>
            <div style={{ width: '20px', height: '20px', display: `${lgScreen ? 'none' : 'block'}` }}></div>
            <div className="verifyCol2 p-4 shadow bg-white rounded">
              <div className="d-flex align-items-center">
                <span className="fs-6 text-secondary">Approval</span>
                <hr className="ms-2" style={{ flexGrow: '1', border: '1px solid rgba(0, 0, 0, 0.12)' }} />
              </div>

              <div>
                <p style={{ fontSize: '12.8px' }}>Song metadata approved or rejected based on compliance with standards and accuracy of information.</p>
              </div>
              <>
                {isApproved.length ? isApproved.map((data, index) => (
                  <Box component="form" noValidate autoComplete="off">
                    <div>
                      <Typography variant="body2" fontWeight={500} style={{ whiteSpace: 'pre-line', fontSize: '14px' }}>{data?.comment || data?.redelivery_comment || '-'} ({data?.approval_date ? formatDateTime(data?.approval_date) : '-'})</Typography>
                    </div>
                  </Box>)) : null}
                {songStatus === 'Rejected' ?
                  (<div className="pt-4">
                    <button className="gn-actionbtn" disabled>
                      {submitButtonText}
                    </button>
                  </div>)
                  : songStatus == 'Ready for Release' ?
                    (
                      <div className='fs-08 status text-light' style={{ backgroundColor: getSongStatusBgColor(songStatus) }}>{songStatus == "Ready for Release" ? 'Approved' : songStatus}</div>

                    )
                    :
                    ("")
                }
              </>
              {songStatus === 'In Review' || songStatus == "Redelivery Requested" ? (
                <React.Fragment>
                  <div className='col-md-12'>
                    <Typography variant='caption'>
                      {songStatus == "Redelivery Requested" ? "Song metadata re-evaluated and approved or rejected based on compliance with standards and accuracy of updated information during redelivery." : ""}
                    </Typography>
                  </div>

                  <div className="col-md-6">
                    <Radio checked={selectedValue === 'True'} onChange={handleRadioButtonChange} value="True" inputProps={{ 'aria-label': 'Approved' }} />
                    Approve
                    <Radio checked={selectedValue === 'False'} onChange={handleRadioButtonChange} value="False" inputProps={{ 'aria-label': 'Rejected' }} />
                    Reject
                  </div>
                  {/* {selectedValue === "False" ? <Box component="form" noValidate autoComplete="off">
                    <div>
                      <TextField
                        id="outlined-multiline-flexible"
                        label="Comment"
                        fullWidth
                        disabled={!selectedValue}
                        // value={comment}
                        error={!!error}
                        helperText={error || ''}
                        multiline
                        maxRows={4}
                        onChange={handleCommentChange}
                        placeholder="Add minimum of 30 characters..."
                        required
                      />
                    </div>
                  </Box> : ""} */}
                  <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
                    <TextField
                      id="outlined-multiline-flexible"
                      label="Comment"
                      fullWidth
                      value={comment}
                      error={selectedValue === "False" && !!error}
                      helperText={selectedValue === "False" ? error : ''}
                      multiline
                      maxRows={4}
                      onChange={handleCommentChange}
                      placeholder={
                        selectedValue === "True"
                          ? "Optional comment..."
                          : "Add minimum of 30 characters..."
                      }
                      required={selectedValue === "False"}
                    />
                  </Box>
                  <div className="pt-4">
                    <button className="gn-actionbtn" disabled={isSubmitDisabled && (comment == "" && selectedValue === 'False')} onClick={(e) => handleSubmit(e, albumId)}>
                      {submitButtonText}
                    </button>
                  </div>
                </React.Fragment>) : (
                ""
              )}

            </div>
          </div>

        </div>
      </div>
      <SnackbarContainer />
    </div >
  );
};

export default SongDetails;